import React, { useEffect, useState } from "react";
import { Table, Space, Switch, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useVehicleModel } from "../vehicleModel";
import { IVehicleDetail } from "../vehicleType";
import useNavModel, { RouterParamType } from "@/model/navModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";



export function DataTable() {
    const { getSelectedNavState, switchNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const {
        dataSource, selectedRowKeys, pgCfg, initPgCfg,
        loadData, setSelectedRowKeys, updateSearchParam, onDisabled
    } = useVehicleModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();
    const columns: ColumnsType<IVehicleDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            fixed: "left",
            render: (text, record, index) => `${index + 1}`
        }, {
            // title: '客户名称',
            title: Locale["Customer"],
            width: 200,
            fixed: "left",
            dataIndex: 'customerName',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '联系人',
            title: Locale["Contact"],
            dataIndex: 'contact',
        }, {
            // title: '车辆类型',
            title: Locale["Vehicle type"],
            dataIndex: 'categoryCode',
            width: 180,
            ellipsis: true,
            // render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0]?.name : getTreeNodeOne(text)[0]?.nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '车辆型号',
            title: Locale["Vehicle Model"],
            width: 160,
            dataIndex: 'model',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '车牌号',
            title: Locale["License Plate"],
            dataIndex: 'licensePlate',
        }, {
            // title: 'VIN码',
            title: Locale["VIN"],
            dataIndex: 'vin',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '发动机号',
            title: Locale["Engine No."],
            width: 160,
            dataIndex: 'engineCode',
        }, {
            // title: '登记人',
            title: Locale["Founder"],
            dataIndex: 'createUser',
        }, {
            // title: '登记日期',
            title: Locale["Record Time"],
            dataIndex: 'createTime',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 160,
            dataIndex: 'note',
        }, {
            // title: '操作',
            title: Locale["Operation"],
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    <Switch checked={text == 1} onChange={(checked) => {
                        onDisabled(record.id as string, checked);

                    }} />
                </Space>
            ),
        }
    ];

    useEffect(() => {
        if (detailsInfo) {
            let { parentInfo } = detailsInfo
            if (parentInfo) {
                loadData(initPgCfg, { customerName: parentInfo.customerName });
                updateSearchParam({ customerName: parentInfo.customerName })
                switchNavState("13-5-2", { id: "", mode: "add" })
            } else {
                loadData();
            }
        } else {
            loadData();
        }
        console.log(detailsInfo)
    }, [detailsInfo]);

    //点击行选高亮
    const onRow = (id: string) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([id as string]);
        }
    };

    return (
        <Table
            rowKey={record => record.id as string}
            rowSelection={{
                type: "radio",
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: IVehicleDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string)
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
